import { createAsyncThunk } from "@reduxjs/toolkit";
import { loginAPI } from "./authApi";
export const login = createAsyncThunk("Auth/login", loginAPI);
